module.exports = __webpack_public_path__ + "static/media/vf_wtshirts_core.40044ed2.svg";